  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>email</mat-icon>
    </span> 
    <p>Add Email</p>   
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
    
  </h2>

  <mat-dialog-content class="mat-typography">

   

    <div class="block mt-10" >
      <div class="relative">
        <mat-form-field appearance="outline">
          <input matInput maxlength="200" class="form-control mtb-15" placeholder="Add email"
            [(value)]="emailAssigned" (input)="emailCheck($event.target.value)" />
        </mat-form-field>

        <button color="primary" *ngIf="addEmailButtonShow"
          (click)="addEmail()" mat-icon-button class="addBtn">
          <mat-icon>add</mat-icon>
        </button> 
      </div>
      
    </div>       
   
    <ul class="selectedlist">
      <li *ngFor="let ass of addUpdateParticipantList">
        <div class="userndetail">
          <div class="userpic">
            <img *ngIf="ass.img!=''" src="{{ass.img}}" alt="">
            <span *ngIf="ass.img==''" class="username">
              {{ass.shortName}}
            </span>
          </div>
          <div class="details">
            <h4>{{ass.name}}</h4>
            <p>{{ass.email}}</p>
          </div>
          <div class="opt">
            <button mat-icon-button matTooltip="Remove">
              <mat-icon (click)="removeParticipant(ass)">cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

    

  </mat-dialog-content>
  
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" 
      (click)="assignTasklistToEmails()" color="primary" [disabled]="showAddButton == true">
      <mat-icon *ngIf="spinner">
        <mat-spinner diameter="20">
      </mat-spinner>
    </mat-icon>
      Done
    </button>  
   
  </mat-dialog-actions>


 

  <app-loader></app-loader>




  

  




